type StatusColors = {
    [key: string]: string;
}

export const status_colors : StatusColors = {
    "TO_START": "#1BC5BD",
    "IN_PROGRESS": "#EEEA0D",
    "FINISHED": "transparent",
    "CANCELED": "#F64E60",
    "BILLED": "#0DA3EE",
    "PAID": "#0D44EE"
}
